<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.theme" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="$dark" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="24">
        <container align="center">
          <btn @click="showLoadingOverlay" color="white" icon-left="reload" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness">{{ $lang.showLoadingOverlay }}</btn>
        </container>
      </flex-col>
    </flex>
  </container>
</template>
<script>
export default {
  name: 'PageLoadingOverlay',
  watch: {
    $dark () {
      setTimeout(() => {
        this.showLoadingOverlay()
      }, 1000)
    }
  },
  methods: {
    showLoadingOverlay () {
      this.$root.ajax = true
      this.hideLoadingOverlay()
    },
    hideLoadingOverlay () {
      setTimeout(() => {
        this.$root.ajax = false
      }, 3000)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/loading-overlay.vue